export default "__VITE_ASSET__BckB5m7D__"